<template>
	<Button
		class="custom-padding d-flex align-items-center gap-3 p-3 bg-transparent text-white"
		:class="[isMobile ? ' justify-content-center' : 'bg-transparent']"
		@click="logout()"
	>
		<i class="pi pi-sign-out" style="transform: rotate(180deg)"></i>
		<span class="p-button-label" style="flex: unset">Cerrar sesión</span>
	</Button>
</template>

<script>
	import { mapActions } from "vuex";
	export default {
		props: {
			isMobile: {
				type: Boolean,
				default: false,
			},
		},
		methods: {
			...mapActions(["logout"]),
		},
	};
</script>

<style lang="scss" scoped>
	.custom-padding {
		padding: 0.75rem 1.25rem !important;
	}

	.bg-transparent {
		transition: $transition;

		&:hover {
			background-color: white !important;
			color: $primary !important;
		}
	}
</style>
